import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=55ab1690"
import script from "./search-page.vue?vue&type=script&lang=js"
export * from "./search-page.vue?vue&type=script&lang=js"
import style0 from "./search-page.vue?vue&type=style&index=0&id=55ab1690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports